<template>
    <div class="office-transfer-card mb-3">
        <loading-screen :isLoading="isDeleting"></loading-screen>

        <div class="inner" :class="{'has-padding-top': officeTransfer.claimed_at}">
            <!--      <b class="audit-name">{{ audit.user ? audit.user.name : 'Unknown user' }}</b> <br>-->

            <div class="top">
                <div class="left">
                    <b class="office-transfer-name">
                        {{ formatDateCustomFormat(officeTransfer.created_at, 'Do MMM YYYY, HH:mm') }}
                    </b>
                </div>
                <div class="right" v-if="!officeTransfer.claimed_at">
                    <b-dropdown variant="white" right toggle-class="text-muted pt-0 pr-0 mt-2">
                        <template v-slot:button-content>
                            <i class="mdi mdi-dots-horizontal font-size-18"></i>
                        </template>
                        <b-dropdown-item @click="requestDelete" variant="danger">Cancel Transfer</b-dropdown-item>
                    </b-dropdown>
                </div>
            </div>

            <div class="mt-2 change-details">
                {{ officeTransfer.transfer_requested_by ? officeTransfer.transfer_requested_by.name : 'Unknown user' }}
                requested
                a transfer to the {{ officeTransfer.office ? officeTransfer.office.name : 'Unknown' }} office.
            </div>
            <hr>
            <div v-if="!officeTransfer.claimed_at" class="pb-1">
                <span class="badge badge-danger font-size-11 w-100 p-2">
                    Unclaimed
                </span>
            </div>
            <div v-if="officeTransfer.claimed_at" class="pb-1">
                <span class="badge badge-success font-size-11 w-100 p-2">
                    Claimed by {{ officeTransfer.claimed_by ? officeTransfer.claimed_by.name : 'Unknown user' }}
                </span>
            </div>
        </div>
    </div>
</template>
  
<script>
import Dates from "../../../../../../mixins/Dates";
import Tickets from "../../../../../../mixins/Tickets";
import { mapActions } from "vuex";
import LoadingScreen from "../../../../../../components/LoadingScreen.vue";
import axios from 'axios';
import Forms from "../../../../../../mixins/Forms";

export default {
    name: "OfficeTransfer",
    props: ['officeTransfer'],
    mixins: [Dates, Tickets, Forms],
    components: { LoadingScreen },
    data() {
        return {
            isDeleting: false
        }
    },
    methods: {
        ...mapActions('ticketViewer', {
            loadOfficeTransfers: 'loadOfficeTransfers',
            loadIfCanClaimTicket: 'loadIfCanClaimTicket'
        }),

        requestDelete() {
            swal({
                title: "Are you sure you want to cancel this office transfer?",
                icon: "warning",
                buttons: {
                    cancel: true,
                    confirm: "Yes, Cancel"
                },
                dangerMode: true,
            }).then((shouldDelete) => {
                if (shouldDelete) {
                    this.delete();
                }
            });
        },

        delete() {
            let vm = this;
            vm.isDeleting = true;
            axios.delete(window.API_BASE + '/tickets/' + vm.officeTransfer.ticket_id + '/office-transfers/' + vm.officeTransfer.id)
                .then(function () {
                    vm.$notify.success({
                        title: 'Success!',
                        message: 'Transfer cancelled successfully'
                    });
                    vm.isDeleting = false;
                    vm.loadOfficeTransfers();
                    vm.loadIfCanClaimTicket();
                })
                .catch(function (e) {
                    vm.isDeleting = false;
                    vm.notifyErrors(e);
                });
        }
    },
    computed: {}
}
</script>
  
<style scoped lang="scss">
.office-transfer-card {
    background: #fff;
    border-radius: 5px;

    .office-transfer-name {
        font-weight: 600;
        color: #2c5cc5;
    }

    .inner {
        //padding-left: 15px;
        //padding-right: 15px;
        padding: 10px;
        padding-top: 0;

        &.has-padding-top {
            padding-top: 10px !important;
        }

        .top {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .left {
                flex-grow: 1;
                display: flex;
                align-items: center;
            }

            .right {
                flex-shrink: 1;
                padding-left: 5px;
                display: flex;
                align-items: center;
            }
        }
    }

    .change-details {
        font-size: 12px;
        line-height: 19px;
    }
}
</style>